/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';

import Information from './../sections/information';
import Interaction from './interaction';
import Prize from './../sections/prize';
import Publish from './../sections/publish';

const sections = [
  { label: 'Apresentação', icon: <ViewAgendaOutlinedIcon />, component: Information },
  { label: 'Interação',   icon: <ChatBubbleOutlineOutlinedIcon />, component: Interaction },
  { label: 'Litros e Preços', icon: <CardGiftcardOutlinedIcon />, component: Prize },
  { label: 'Publicação',  icon: <PublishOutlinedIcon />, component: Publish },
];

const TanqueCheioTabs = ({
  value,
  handleNativeChange,
  formValues,
  handleOpenConfirmation,
  handleCancelClose,
  openConfirmation,
  setOpenConfirmation,
  onClickProgress,
  goBack,
  closeModal,
  router,
  location,
}) => {
  const Section = sections[value].component;

  const prev = () => {
    handleNativeChange(null, Math.max(0, value - 1));
  };

  const handleNext = () => {
    const nextValue = Math.min(sections.length - 1, value + 1);
    handleNativeChange(null, nextValue);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          px: 2,
          py: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {sections[value].icon}
          <Typography variant="subtitle2" sx={{ fontWeight: 'medium', fontSize: 16 }}>
            {sections[value].label}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="caption">
            {value + 1} de {sections.length}
          </Typography>
          <IconButton size="small" onClick={prev} disabled={value === 0}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={handleNext}
            disabled={value === sections.length - 1}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
        <Section
          formValues={formValues}
          handleOpenConfirmation={handleOpenConfirmation}
          handleCancelClose={handleCancelClose}
          openConfirmation={openConfirmation}
          setOpenConfirmation={setOpenConfirmation}
          onClickProgress={onClickProgress}
          goBack={goBack}
          closeModal={closeModal}
          router={router}
          location={location}
          handleNativeChange={handleNativeChange}
          value={value}
          confirmationTitle="Deseja sair da edição?"
          confirmationSubtitle="Lembre-se, as informações que não foram salvas serão perdidas."
          buttonConfirmationLabel="Sim, sair da edição"
        />
      </Box>
    </Box>
  );
};

TanqueCheioTabs.propTypes = {
  value: PropTypes.number.isRequired,
  handleNativeChange: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  handleOpenConfirmation: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  setOpenConfirmation: PropTypes.func.isRequired,
  onClickProgress: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default TanqueCheioTabs;
